<template>
  <div class="row">
     <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :is-full-page="true">
    </loading>
    <div class="col-lg-12 text-center">
      Déconnexion...
    </div>
  </div>
</template>
<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';

  export default {
    components: {
      Loading
    },
    methods: {
      
    },
    data() {
      return {
        isLoading: true,
      }
    },
    async mounted() {
      // handle logout here
      localStorage.removeItem('token');
      this.$router.go()
    },
  }
</script>
<style>
</style>
